import { PAGES } from "@dune/types";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
	useGetAssureurProjects,
	useGetAssureurReceipts,
} from "../../api/queries/dashboard.queries";
import { useMe } from "../../api/queries/users.queries";
import ErrorBoundary from "../../component/common/ErrorBoundary";
import { DashboardHeader } from "./components/DashboardHeader";
import { ProjectsSection } from "./components/ProjectsSection";
import { ReceiptsCard } from "./components/ReceiptsCard";

const AssureurDashboard: React.FC = () => {
	const navigate = useNavigate();
	const { me } = useMe();

	const assureurProjectsQuery = useGetAssureurProjects();
	const assureurReceiptsQuery = useGetAssureurReceipts();

	const handleNewProject = () => {
		navigate(PAGES.PROJECTS.create);
	};

	return (
		<div className="h-screen overflow-hidden flex flex-col bg-white rounded-lg border">
			<ErrorBoundary fallbackMessage="Erreur lors du chargement du tableau de bord">
				<div className="flex-shrink-0 p-6 pb-4">
					<DashboardHeader
						firstName={me?.firstname || ""}
						onNewProject={handleNewProject}
						isNewProject={false}
					/>
				</div>
				<div className="flex-1 px-6 pb-6 overflow-hidden">
					<div className="h-full grid grid-cols-4 gap-6">
						<div className="col-span-1 flex flex-col gap-4 overflow-hidden">
							<div className="flex-shrink-0">
								<ReceiptsCard
									totalCount={assureurReceiptsQuery.data?.totalCount}
									isLoading={assureurReceiptsQuery.isLoading}
									error={assureurReceiptsQuery.error}
								/>
							</div>
						</div>
						<div className="col-span-3 min-h-0">
							<ProjectsSection
								projectsData={assureurProjectsQuery.data}
								isLoading={assureurProjectsQuery.isLoading}
								error={assureurProjectsQuery.error}
							/>
						</div>
					</div>
				</div>
			</ErrorBoundary>
		</div>
	);
};

export default AssureurDashboard;
